import styled from 'styled-components/macro';
import { COLORS } from 'styleguide';
import SimpleButton from 'styled/Buttons/SimpleButton';

const TabStyled = styled(SimpleButton)`
  position: relative;
  margin: 0 10px;
  padding: 0 0 10px;
  letter-spacing: 0.6px;
  color: #fff;
  opacity: 0.4;
  font-size: 12px;
  text-transform: uppercase;
  outline: none;
  transition: opacity 0.15s ease-out;

  &:first-child {
    margin-left: 0;
  }

  &:last-child {
    margin-right: 0;
  }

  ${props => props.active && `
    opacity: 1;

    &::after {
      content: '';
      position: absolute;
      left: 0;
      bottom: -5px;
      height: 2px;
      width: 100%;
      background: ${COLORS.primary};
    }
  `}

  &:hover,
  &:focus {
    opacity: 1;
  }
`;

export default TabStyled;
